var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c(
            "form",
            {
              staticClass: "form-inline",
              attrs: {
                method: "POST",
                action: _vm.action,
                enctype: "multipart/form-data"
              }
            },
            [
              _c("input", {
                attrs: { type: "hidden", name: "_token" },
                domProps: { value: _vm.token }
              }),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2)
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card__content" },
          [
            _c("k-table", {
              ref: "cie10",
              attrs: {
                path: _vm.path,
                createButton: _vm.permiteCrear,
                editButton: _vm.permiteEditar,
                deleteButton: _vm.permiteEliminar,
                exportable: "",
                columns: [
                  {
                    display: "Cie10 Principal",
                    value: "padre.nombre"
                  },
                  {
                    display: "Código",
                    value: "codigo"
                  },
                  {
                    display: "Descripción",
                    value: "descripcion"
                  },
                  {
                    display: "Creación",
                    value: "created_at"
                  },
                  {
                    display: "Modificación",
                    value: "updated_at"
                  }
                ]
              },
              on: {
                editar: _vm.editar,
                crear: _vm.crear,
                eliminar: _vm.eliminar
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { name: "cie10", scrollable: "", width: "70%", height: "auto" }
        },
        [
          _c("k-cie10", {
            on: { saved: _vm.saved, cancelar: _vm.cancelar },
            model: {
              value: _vm.selectedCie10,
              callback: function($$v) {
                _vm.selectedCie10 = $$v
              },
              expression: "selectedCie10"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Consulta de CIE10")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-field" }, [
      _c("label", { attrs: { for: "archivo" } }, [
        _c("strong", [_vm._v("Importación CIE10")])
      ]),
      _vm._v(" "),
      _c("input", { attrs: { type: "file", name: "archivo", id: "archivo" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-field" }, [
      _c("button", { staticClass: "btn-success", attrs: { type: "submit" } }, [
        _c("i", { staticClass: "fa fa-upload" }),
        _vm._v(" "),
        _c("span", [_vm._v("Subir")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7609f8f1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7609f8f1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/cie10/ConsultaCie10.vue
// module id = 573
// module chunks = 0